import React from "react";
import { backdropClasses, Dialog } from "@mui/material";
import { makeStyles } from "@mui/styles";
import "../../Sass/Common.scss";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import PatientsCreateAndEdit from "../../Components/Patients/PatientsCreateAndEdit";
import clsx from "clsx";
import { ReactComponent as PatientDetails } from "../../Assets/Icons/PharmsmartIcon/PatientDetails.svg";
// const PatientsCreateAndEdit = React.lazy(() =>
//   import("Components/Patients/PatientsCreateAndEdit")
// );

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
      padding: "7.5px 108px 7.5px 6px !important",
    },
  },
  rsUpdateDialog: {
    "&>div": {
      "&>div": {
        background: "#efefef",
        maxHeight: "calc(100% - 20px)",
        padding: "10px 0px !important",
        borderRadius: "10px !important",
        "&>div:nth-child(1)": {
          "&>h2": {
            "&>p": {
              paddingBottom: "10px",
            },
          },
          "&>div:nth-child(1)": {
            paddingTop: "10px",
            "&>svg": {
              height: "50px",
              width: "50px",
            },
          },
        },
      },
    },
    "& .MuiPaper-root.MuiPaper-elevation": {
      // top: "0 !important",
      // marginLeft: "20px",
      // marginRight: "20px",
      maxWidth: "1215px",
      top: "-15px !important",
      "&>div": {
        paddingTop: "0px",
        paddingBottom: "0px",
      },
    },
  },
}));
// Patient(List) and WaitingList(List), Repeat Order(List) Modules Edit-Patient Dialog
function PatientCreateDialog({
  open,
  setOpen,
  callBackOnSubmit,
  callBackOnCancel,
  createNewPatientFromCSV,
  fromPatientDetails,
  _patientId,
  orderCountPayload,
  countUpdateFlag,
}) {
  const classes = useStyles();

  /** handle close */
  const handleClose = () => {
    setOpen(false);
  };

  const callBackOfPatientFormSubmit = (responseData) => {
    handleClose();
    if (typeof callBackOnSubmit === "function") {
      callBackOnSubmit(responseData);
    }
  };

  const callBackOfPatientFormCancel = () => {
    handleClose();
    if (typeof callBackOnCancel === "function") {
      callBackOnCancel();
    }
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"lg"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className={clsx("RSxs_modal", classes.rsUpdateDialog)}
      >
        <PrimaryDialogTitle
          handleClose={handleClose}
          title="Edit Patient"
          icon={PatientDetails}
        />
        <PatientsCreateAndEdit
          openImportCsvPatientForm={open}
          _pageAccessMode="edit"
          _patientId={_patientId}
          callBackOnSubmit={callBackOfPatientFormSubmit}
          callBackOnCancel={callBackOfPatientFormCancel}
          // createNewPatientFromCSV={createNewPatientFromCSV}
          fromPatientDetails
          dialog={true}
          orderCountPayload={orderCountPayload}
          countUpdateFlag={countUpdateFlag}
        />
      </Dialog>
    </>
  );
}

export default PatientCreateDialog;
